document.addEventListener('click', function(e) {
  if (e.target.classList.contains('cart-drawer-upgrade-subscription-btn')) {
    const line = e.target.getAttribute('data-line');
    const planId = e.target.getAttribute('data-plan-id');
    const quantity = e.target.getAttribute('data-qty');

    const formData = {
      line: line,
      quantity: quantity,
      selling_plan: planId
    };

    console.log({
      message: "Button clicked",
      formData: formData
    });

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(cart => {

        /* I think this is right for Hehku - need to confirm */
      // document.dispatchEvent(new CustomEvent('cart:update', {
      //   bubbles: true,
      //   detail: cart
      // }));

      const cartElement = document.querySelector('cart-items') || document.querySelector('cart-drawer');

      if (cartElement && typeof cartElement.renderAndShowItems === 'function') {
        // This is the specific Hehku method that re-fetches the HTML and opens the drawer
        cartElement.renderAndShowItems(); 
      } else {
        // If for some reason the method isn't found, fallback to a page refresh
        window.location.reload();
      }

    })
    .catch(error => console.error('Error upgrading:', error));
  }
});

